module.exports = __webpack_public_path__ + "img/event_carpet_expoluxe_9520_black.efc80290.jpg";